import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { LuMinus, LuTrendingDown, LuTrendingUp } from "react-icons/lu";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getTrendIndicator(currentPoints, previousPoints) {
  if (!Number.isFinite(previousPoints) || currentPoints === previousPoints) {
    return { icon: LuMinus, className: "text-slate-400" };
  }

  if (previousPoints === 0) {
    return currentPoints > 0
      ? { icon: LuTrendingUp, className: "text-emerald-600" }
      : { icon: LuMinus, className: "text-slate-400" };
  }

  return currentPoints > previousPoints
    ? { icon: LuTrendingUp, className: "text-emerald-600" }
    : { icon: LuTrendingDown, className: "text-rose-600" };
}
